import Modal from '@cp/src/components/Modal/Modal';
import Button from '@navi/web-ui/lib/primitives/Button';

interface IDeleteConfirmationModalProps {
  isModalOpen: boolean;
  onClose: () => void;
  handleDeleteExperiment: () => void;
  title: string;
}

const DeleteConfirmationModal = (props: IDeleteConfirmationModalProps) => {
  const { isModalOpen, onClose, handleDeleteExperiment, title } = props;

  return (
    <Modal
      visible={isModalOpen}
      onClose={onClose}
      header={title}
      headerClassName="!px-6 !pt-6 max-w-[460px]"
      contentClassName="max-w-[460px]"
      showCloseIcon={false}
      closeOnOutsideClick
    >
      <div className="flex w-full justify-between gap-3 mt-5">
        <Button variant={'secondary'} onClick={onClose} className="w-full">
          Cancel
        </Button>
        <Button variant={'primary'} onClick={handleDeleteExperiment} className="w-full">
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
